<div>
  <form id="payment-form">
    <div id="payment-element">
      <!-- Stripe Payment Element will be inserted here -->
      <h1 *ngIf="!isStripeLoadedError && isStripeLoading" class="loading-text">Stripe Payment Element Loading...</h1>
      <h1 *ngIf="isStripeLoadedError" class="loading-text">Stripe Payment Element Failed to Load</h1>
    </div>
  </form>
</div>